module.exports = __webpack_public_path__ + "img/zhuanli.e20ef4a.png";